import { Stack, Typography } from '@mui/material';
import { useInView } from 'framer-motion';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import type { CustomComponentProps } from '../ComponentSlot.types';
import { StyledStatsCard, StyledImage } from './MatchStats.styles';
import type { MatchStatsProps } from './MatchStats.types';
import { MatchStatsLabel } from './MatchStatsLabel';

export const MatchStats: React.FC<CustomComponentProps> = ({ props }) => {
  const {
    homeTeamColor,
    awayTeamColor,
    stats,
    eventsImage,
    removeMarginTop = false,
    removeMarginBottom = false,
  } = props as MatchStatsProps;

  const animatedStats = stats.map((stat) => {
    return {
      ...stat,
      team1Value: 0,
      team2Value: 0,
    };
  });

  const animatedStatsRef = useRef(null);
  const inView = useInView(animatedStatsRef);

  const [currentStats, setCurrentStats] = useState(animatedStats);

  const updateStats = useCallback(() => {
    if (inView) {
      setTimeout(() => {
        setCurrentStats(stats);
      }, 200);
    }
  }, [inView, stats]);

  useEffect(() => {
    updateStats();
  }, [updateStats]);

  return (
    <Stack
      sx={(theme) => ({
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: '1rem', md: '1.5rem' },
        ...(removeMarginTop && {
          marginTop: {
            xs: theme.spacing(-2),
            md: theme.spacing(-4),
          },
        }),
        ...(removeMarginBottom && {
          marginBottom: {
            xs: theme.spacing(-2),
            md: theme.spacing(-4),
          },
        }),
      })}>
      <StyledStatsCard>
        <Typography variant={'paragraphMdEmphasis'}>STATS</Typography>
        <Stack gap={2} ref={animatedStatsRef}>
          {currentStats.map(
            ({ label, team1Value, team2Value, usePercentage }) => {
              return (
                <MatchStatsLabel
                  key={label}
                  label={label}
                  team1Value={team1Value}
                  team2Value={team2Value}
                  usePercentage={usePercentage}
                  awayTeamColor={awayTeamColor}
                  homeTeamColor={homeTeamColor}
                />
              );
            }
          )}
        </Stack>
      </StyledStatsCard>
      <StyledStatsCard>
        <StyledImage src={eventsImage} alt="events" />
      </StyledStatsCard>
    </Stack>
  );
};
